import React from "react";
import { Button } from "../ui";
import { ConversationTranscript } from "../marketing";

export function CTABlock() {
  return (
    <section className="bg-surface-sunk border-t border-line">
      <div className="container-bc py-16 md:py-24 grid gap-10 lg:grid-cols-2 items-center">
        <div>
          <h2 className="text-3xl md:text-4xl tracking-tight text-ink-950">Put an AI sales agent in your inbox today.</h2>
          <p className="mt-4 text-lg text-ink-600 max-w-prose">It reads, replies, qualifies and books — across every channel your customers already use. Live in about fifteen minutes.</p>
          <div className="mt-6 flex flex-wrap gap-3">
            <Button href="https://tidycal.com/theryanslvdr/bconnect-intro" target="_blank" rel="noreferrer" variant="primary" size="lg" data-testid="cta-talk-btn">Talk to Us</Button>
            <Button to="/pricing/" variant="secondary" size="lg" data-testid="cta-pricing-btn">See pricing</Button>
          </div>
        </div>
        <ConversationTranscript
          channel="WhatsApp"
          messages={[
            { from: "them", text: "do you ship to Cebu? and how much for 2?", time: "09:41" },
            { from: "agent", text: "Yes, we ship to Cebu next-day. Two units is \u20b12,400 delivered. Want me to reserve stock and send the payment link?", time: "09:41" },
            { from: "them", text: "go", time: "09:42" },
          ]}
        />
      </div>
    </section>
  );
}
